<template>
  <div class="historyPage">
    <TopBack :title="$t('lang.menu.History')"/>
    <div class="change-select">
      <Select
        class="left-select"
        :defaultValue="$route.query.type && $route.query.type === 'w' ?{text:$t('lang.history.Withdrawal'),value:'withdrawal'}:{text:$t('lang.history.All'),value:'total'}"
        :items="typeItems"
        @selected="selectType"
      ></Select>
      <Select
        class="right-select"
        :defaultValue="  {text:$t('lang.history.Last7days'),value:'7'}"
        :items="dateItems"
        @selected="selectDate"
      ></Select>
    </div>
    <div class="historyContainer" id="historyContainer">
      <Loadmore
        :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
        :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
        :bottomLoadingText="$t('lang.loadingStatus.loading')"
        :auto-fill="false"
        :bottom-method="fetchHistory"
        :bottom-all-loaded="hasLoadAll"
        ref="loadmore">
        <div class="historyItem" v-for="(item, index) in historyList" :key="index" @click="goDetail(item)">
          <div class="left">
            <div class="lineOne">
              <div class="typeIcon">
                <!--                  Gift-->
                <img v-if="item.Type ==='Deposit' || item.Type ==='Withdrawal' || item.Type === 'Withdrawal Fee'"
                     src="../../assets/images/history/wallet.svg" alt="">
                <img v-if="item.Type === 'Gift'" src="../../assets/images/history/gift.svg" alt="">
                <img
                  v-if="item.Type !=='Deposit' && item.Type !=='Withdrawal' && item.Type !== 'Withdrawal Fee' && item.Type !== 'Gift'"
                  src="../../assets/images/history/game.svg" alt="">
              </div>
              <div class="typeName">
                <div>{{ $t('lang.history.' + item.Type) }}</div>
              </div>
              <div v-if="item.GameNameEn" :class="item.Type==='Promotion Rewards'?'gameName':'longgameName'">
                <div class="arrow-img"><img src="../../assets/images/history/arrowright.svg" alt=""></div>
                <span>{{ item.GameNameEn }}</span>
              </div>
              <div v-if="item.Type.indexOf('Tw_')>-1" class="longgameName">
                <div class="arrow-img"><img src="../../assets/images/history/arrowright.svg" alt=""></div>
                <span>9 Wickets</span>
              </div>
            </div>
            <div class="lineTwo" v-if="item.Type ==='Deposit' || item.Type ==='Withdrawal'">
              <span>{{ $t('lang.history.billNumber') }}</span>
              <span class="bill"
                    @click.stop="copyId(item.TransactionUuid)">{{ item.TransactionUuid }}</span>
              <img src="../../assets/images/history/copy.svg" alt="" @click.stop="copyId(item.TransactionUuid)">
            </div>
            <div class="lineThree">
              {{ $t('lang.history.Balance') }}: <span class="balance">{{
                fetchCurrency[currency]
              }}{{ separateThousand(item.TotalBalance) }}</span>
            </div>
          </div>
          <div class="right">
            <div class="line-One" v-if="item.Type ==='Deposit' || item.Type ==='Withdrawal'">
              <span class="status" :style="statusColor(item.Status)">{{ statusName(item) }}</span>
            </div>
            <div class="line-Two">
              {{ fetchCurrency[currency] }}{{ separateThousand(item.Amount) }}
            </div>
            <div class="line-Three">
              <div>{{ item.TransactionDate }}</div>
            </div>
          </div>
        </div>
        <div class="showMore" v-if="!hasLoadAll">
          <div class="shadow"/>
          <img :src="showMore" alt="">
        </div>
      </Loadmore>
    </div>
  </div>
</template>

<script>
import {Loadmore, Toast} from 'mint-ui'
import TopBack from '@/components/TopBack/index'
import Select from '../../components/Select/index.vue'
import request from '@/service'
import {separateThousand} from '@/utils'
import {fetchCurrency} from '@/constant'
import deposit from '@/assets/images/common/deposit.svg'
import withdraw from '@/assets/images/common/withdraw.svg'
import showMore from '@/assets/images/history/showMore.svg'

export default {
  name: 'History',
  data () {
    return {
      typeItems: [
        {text: this.$t('lang.history.All'), value: 'total'},
        {text: this.$t('lang.history.Deposit'), value: 'deposit'},
        {text: this.$t('lang.history.Withdrawal'), value: 'withdrawal'},
        {text: this.$t('lang.history.EventGift'), value: 'gift'},
        {text: this.$t('lang.history.PromotionReward'), value: 'reward'},
        {text: this.$t('lang.history.Bonus'), value: 'bonus'},
        {text: this.$t('lang.history.Win'), value: 'win'},
        {text: this.$t('lang.history.Bet'), value: 'bet'},
        {text: this.$t('lang.history.Transfer'), value: 'transfer'}
      ],
      dateItems: [
        {text: this.$t('lang.history.Last7days'), value: '7'},
        {text: this.$t('lang.history.Last15days'), value: '15'},
        {text: this.$t('lang.history.Last30days'), value: '30'}
      ],
      skipNum: 0,
      takeNum: 10,
      historyList: [],
      hasLoadAll: true,
      currency: JSON.parse(localStorage.getItem('userInfo')).CurrencyName,
      fetchCurrency,
      deposit,
      withdraw,
      separateThousand,
      firstLoad: true,
      showMore,
      check: 0,
      date: 7,
      type: 'total',
      selected: {
        aid: 'total'
      },
      selected2: {
        aid: 7
      }
    }
  },
  components: {
    TopBack,
    Loadmore,
    Select
  },
  watch: {
    '$store.state.locale': function (val) {
      this.freshType()
      this.freshDate()
    }
  },
  computed: {
    statusColor () {
      return (status) => {
        switch (status) {
          case 'done':
            return {background: '#006723', color: '#000', borderRadius: '0.7vw', padding: '0.2vw 0.9vw'}
          case 'rejected':
            return {background: '#91000E', color: '#000', borderRadius: '0.7vw', padding: '0.2vw 0.9vw'}
          default:
            return {
              background: '#606060',
              color: '#000',
              borderRadius: '0.7vw',
              padding: '0.2vw 0.9vw',
              'white-space': 'nowrap'
            }
        }
      }
    },
    statusName () {
      return (item) => {
        if (item.Status === 'processing' && item.Type === 'Withdrawal') {
          const date2 = new Date(item.TransactionDate.replace(' ', 'T'))
          return this.isDate1ExceedingByMinutes(new Date(), date2, 10) ? this.$t('lang.history.pending') : this.$t('lang.history.processing')
        } else {
          return this.$t('lang.history.' + item.Status)
        }
      }
    }
  },
  mounted () {
    // this.fetchHistory()
  },
  methods: {
    freshType () {
      this.typeItems = [
        {text: this.$t('lang.history.All'), value: 'total'},
        {text: this.$t('lang.history.Deposit'), value: 'deposit'},
        {text: this.$t('lang.history.Withdrawal'), value: 'withdrawal'},
        {text: this.$t('lang.history.EventGift'), value: 'gift'},
        {text: this.$t('lang.history.PromotionReward'), value: 'reward'},
        {text: this.$t('lang.history.Bonus'), value: 'bonus'},
        {text: this.$t('lang.history.Win'), value: 'win'},
        {text: this.$t('lang.history.Bet'), value: 'bet'}
      ]
    },
    freshDate () {
      this.dateItems = [
        {text: this.$t('lang.history.Last7days'), value: '7'},
        {text: this.$t('lang.history.Last15days'), value: '15'},
        {text: this.$t('lang.history.Last30days'), value: '30'}
      ]
    },
    selectType (selectValval) {
      if (selectValval.value === this.type) return false
      this.skipNum = 0
      this.check = 1
      this.type = selectValval.value
      this.fetchHistory(true)
    },
    selectDate (selectValval) {
      if (selectValval.value === this.date) return false
      this.skipNum = 0
      this.check = 1
      this.date = selectValval.value
      this.fetchHistory(true)
    },
    copyId (id) {
      // 进行复制
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', id)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
      Toast(this.$t('lang.account.copySuccess'))
    },
    isDate1ExceedingByMinutes (date1, date2, span) {
      console.log(new Date(date2.getTime() + span * 60 * 1000))
      const date2PlusTenMinutes = new Date(date2.getTime() + span * 60 * 1000)
      return date1 > date2PlusTenMinutes
    },
    fetchHistory (toTop) {
      const url = '/innovation/transactions/history'
      const data = {
        userId: JSON.parse(localStorage.getItem('userInfo')).UserId,
        skip: this.skipNum,
        take: this.takeNum,
        date: this.date,
        type: this.type
      }
      request('post', url, data).then(res => {
        if (this.check > 0) {
          this.historyList = res.Transactions
        } else {
          this.historyList = this.historyList.concat(res.Transactions)
        }
        this.skipNum += this.takeNum
        this.hasLoadAll = this.skipNum >= res.Total
        if (!this.firstLoad) {
          this.$refs.loadmore.onBottomLoaded()
        }
        this.firstLoad = false
        this.check = 0
        if (toTop && toTop === true) {
          setTimeout((e) => {
            document.getElementById('historyContainer').scrollTo(0, 0)
          }, 0)
        }
      })
    },
    plusOrMinus (type) {
      switch (type) {
        case 'bet':
        case 'withdrawal':
          return '-'
        case 'win':
        case 'deposit':
          return '+'
      }
    },
    goDetail (item) {
      if (item.Type === 'Withdrawal') {
        this.$router.push({
          path: '/WithdrawalSuccessful',
          query: {
            Transaction: JSON.stringify(item)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mint-loadmore {
  padding-top: 2vw;
}

.historyPage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding-top: 56px;
  overflow: hidden;

  .change-select {
    height: 7.6vw;
    width: 100vw;
    border-radius: 1.111vw;
    margin: 2.7vw 0 3.2vw 0;
    padding: 0 4.444vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .left-select {
    height: 8.333vw;
    width: 50.1138vw;
    margin: 0 0.277vw;
    font-size: 4.444vw;
    line-height: 8.333vw;
  }

  .right-select {
    height: 8.333vw;
    width: 36.447vw;
    margin: 0px 1px 0px 0px;
    float: right;
    font-size: 4.444vw;
    line-height: 8.333vw;
  }

  ::v-deep {
    .el-input__inner {
      &::placeholder {
        color: red;
      }
    }
  }

  .historyContainer {
    padding: 0 4.44vw;
    height: calc(100vh - 94px - 13.7vw);
    overflow: auto;

    .historyItem {
      margin: 0 auto 2.5vw auto;
      border-radius: 1.111vw;
      background-color: #2F2F2F;
      width: 91.4vw;
      min-height: 15.277vw;
      padding: 2.3vw;
      display: flex;
      justify-content: space-between;

      .left {
        width: 70%;
        height: max-content;

        .lineOne {
          width: 100%;
          height: 4.4444vw;
          margin-bottom: 2.361vw;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .typeName {
            max-width: 39.71vw;
            font-weight: 600;
            color: #ffffff;
            margin-left: 1.8vw;
            white-space: nowrap;
            font-family: Inter;
            font-weight: 600;
            font-size: 4.166vw;
            line-height: 100%;
            text-align: center;
            text-transform: capitalize;

          }

          .longgameName {
            font-size: 2.6vw;
            color: #646464;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-left: 1vw;
            display: flex;
            align-items: flex-end;

            .arrow-img {
              margin-right: 0.5vw;
              height: 2.5vw;
              width: max-content;

              img {
                height: 100%;
                width: auto;
              }
            }

            span {
              line-height: 2.5vw;
            }
          }

          .typeIcon {
            width: 5.22vw;
            height: 2.16vh;

            image {
              height: 100%;
              width: 100%;
            }
          }
        }

        .lineTwo {
          width: 100%;
          height: 3.611vw;
          line-height: 3.611vw;
          margin-bottom: 0.833vw;
          font-family: Arial;
          font-weight: 700;
          font-size: 11px;
          letter-spacing: -0.035em;
          text-transform: capitalize;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: #E0E0E0;

          .bill {
            margin-left: 0.75vw;
            text-decoration: underline;
            font-weight: 400;
            color: #DFDFDF;
          }

          img {
            margin-top: 0.05vw;
            margin-left: 1vw;
            width: 2.3vw;
            height: auto;
          }
        }

        .lineThree {
          width: 100%;
          height: 3.611vw;
          line-height: 3.611vw;
          font-family: Arial;
          font-weight: 700;
          font-size: 3.055vw;
          text-transform: capitalize;
          color: #E0E0E0;

          .balance {
            font-family: Arial;
            font-weight: 400;
            text-transform: capitalize;
            letter-spacing: -0.035em;
            color: #DFDFDF;
          }
        }
      }

      .right {
        position: relative;
        width: 30%;

        .line-One {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          height: 4.1666vw;
          margin-bottom: 1.3vw;

          .status {
            font-family: Arial;
            font-weight: 400;
            font-size: 3.0555vw;
            text-transform: capitalize;
          }
        }

        .line-Two {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          white-space: nowrap;
          font-family: Inter;
          font-weight: 500;
          font-size: 4.444vw;
          letter-spacing: -0.009em;
          text-transform: capitalize;
          color: #FFFFFF;
          line-height: 3.611vw;
        }

        .line-Three {
          position: absolute;
          right: 0;
          bottom: 0.5vw;
          font-family: Arial;
          font-weight: 400;
          font-size: 3.055vw;
          line-height: 3.055vw;
          color: #DBDBDB;
          white-space: nowrap;
          display: flex;
          justify-content: flex-end;
        }
      }
      .time {
        font-size: 12px;
        line-height: 14px;
        color: #fff;
      }

      .content {
        position: relative;
        width: 91.4vw;;
        display: flex;

        .contentLeft {
          width: 14.67vw;

          .type {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 12.5vw;
            height: 12.5vw;
            overflow: hidden;
            background: #F6D9AA;
            font-size: 4vw;
            font-weight: 700;
            line-height: calc(2.8vw + 3px);
            letter-spacing: -0.035em;
            text-align: center;
            color: #000000;
            word-break: break-all;
            border-radius: 3px;

            div {
              width: 90%;
            }
          }
        }

        .contentMiddle {
          position: relative;
          display: flex;
          flex-direction: column;
          width: 55vw;
          height: 12.5vw;
          padding-left: 1.5vw;
          text-align: right;
          overflow: hidden;

          .date {
            top: 0;
            left: 0;
            white-space: nowrap;
            font-size: 3.4vw;
            font-weight: 400;
            line-height: 6.8vw;
            text-align: left;
            color: #D0D0D0;
          }

          .amount-status {
            position: relative;
            display: flex;
            bottom: 1vw;

            .amount {
              position: relative;
              white-space: nowrap;
              color: #ffffff;
              font-size: 5.6vw;
              line-height: 7.7vw;
              font-weight: 400;
              text-align: left;
              letter-spacing: -0.5vw;

              span {
                font-weight: 400;
                font-size: 4vw;
                line-height: 5.6vw;
                text-align: left;
              }
            }

            .status {
              position: relative;
              top: 0;
              left: 2vw;
              display: flex;
              flex-direction: column;
              font-weight: 400;
              font-size: 3.5vw;
              line-height: 4vw;
              text-align: left;
              color: #000000;
              border-radius: 1vw;
              text-transform: capitalize;
            }
          }
        }

        .contentRight {
          position: absolute;
          right: 2vw;
          display: flex;
          flex-direction: column;
          width: 40vw;
          height: 12vw;
          margin: 1vw 2vw;

          .balance {
            position: relative;
            white-space: nowrap;
            font-size: 3.3vw;
            font-weight: 400;
            line-height: 4.27vw;
            text-align: right;
            color: #DBDBDB;
            opacity: 0.6;

          }

          .gameName {
            position: relative;
            color: #F6D9AA;
            font-size: 3.6vw;
            line-height: 3.5vw;
            font-weight: 400;
            text-align: right;
            min-height: 6.5vw;
          }
        }
      }
    }

    .showMore {
      position: relative;
      left: 50%;
      transform: translate(-50%);
      width: 100vw;
      height: 16vw;
      text-align: center;

      .shadow {
        position: absolute;
        bottom: 12vw;
        width: 100%;
        background: linear-gradient(180deg, rgba(22, 22, 22, 0) 0%, #161616 75.93%);
        height: 26.389vw;
        z-index: 0;
      }

      img {
        position: relative;
        width: 3.611vw;
        z-index: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/History/index.vue